import { makeStyles } from "@mui/styles";

const styles = makeStyles(() => ({
  modal: {
    maxWidth: "520px !important",
  },
  textRelinkModal: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#475467",
  },
}));

export default styles;
